import App from './App.svelte';

const app = new App({
	target: document.querySelector('svelteapp'),
	hydrate: true
});

export default app;